import React, { useState, useEffect, useRef } from 'react';
import Container from 'container';
import Headline from 'headline';
import ArticleCard from 'shared/article-card';
import Swiper from 'react-id-swiper';
import { Link } from 'gatsby';
import categories from 'data/categories.json';
import Icon from 'icon';
import s from './article_group_5.module.scss';

const demoArticle = {
  title: 'This is the article title',
  date: '2019-05-23T18:38:10',
  image: 'placeholder',
  excerpt: `
    <p>
    Lorem ipsum, dolor sit amet consectetur adipisicing elit. Exercitationem
    ab aliquid accusantium molestiae temporibus in, inventore est nam veniam
    quia neque vel voluptates reiciendis eos alias accusamus id nemo quam
    fugiat porro consectetur nesciunt. Et fuga culpa dolore! Modi reiciendis
    aliquid nostrum illo doloribus reprehenderit eveniet laboriosam blanditiis
    in, accusamus, natus nemo maxime iure, voluptatem ipsum? Odio
  </p>`,
  categories: ['travel'],
  author: 'Joseph Casanova',
  editor: 'Elizabeth Williams',
  illustrator: 'Alexis Michaud'
};

export default function ArticleGroup5({
  articles = new Array(4).fill(demoArticle),
  title = '<h4>headline title</h4>',
  category
}) {
  const swiper = useRef();
  const updateSwiper = mySwiper => {
    swiper.current = mySwiper;
  };

  const params = {
    Swiper,
    slidesPerView: 4,
    slidesPerGroup: 4,
    spaceBetween: 30,
    preloadImages: false,
    breakpoints: {
      768: {
        slidesPerColumn: 4,
        slidesPerGroup: 1,
        slidesPerView: 1
      }
    }
  };
  const catName = categories[category]?.name;
  const catSlug = categories[category]?.slug;

  const handleWindowResize = () => { // FIX for the MOST annoying swiper lib bug EVER EXISTED
    if (swiper && swiper.current) {
      if (window.innerWidth > 768) {
        swiper.current.classNames = swiper.current.classNames.filter(
          aclass => aclass !== 'swiper-container-multirow'
        );
        swiper.current.el.classList.remove('swiper-container-multirow');
      } else {
        swiper.current.classNames.push('swiper-container-multirow');
        swiper.current.el.classList.add('swiper-container-multirow');
      }
      swiper.current.update();
    }
  };

  useEffect(() => {
    handleWindowResize();
    window.addEventListener('resize', handleWindowResize);
    return () => window.removeEventListener('resize', handleWindowResize);
  }, []);

  return (
    <Container className={s.root}>
      <div className={s.wrapper}>
        <Headline h2 className={s.headline} html={title} />
        <Link className={`${s.viewAll} ${s.desktop}`} to={`/${catSlug}/`}>
          <span>{`View all ${catName} posts`}</span>
          <Icon className={s.arrow} icon="arrow-circle" />
        </Link>
      </div>
      <div className={s.cards}>
        <Swiper getSwiper={updateSwiper} {...params}>
          {articles.map(card => (
            <div
              className={s.article}
              key={`group-articles-page-${Math.random()}`}
            >
              <ArticleCard
                small
                inSlider
                {...card}
                key={card.title}
                slim
                className={s.card}
              />
            </div>
          ))}
        </Swiper>
      </div>
      <Ellipses
        {...{
          swiper,
          updateSwiper,
          ellipses: new Array(Math.ceil(articles.length / 4)).fill('beer')
        }}
      />
      <Link className={`${s.viewAll} ${s.mobile}`} to={`/${catSlug}/`}>
        <span>{`View all ${catName} posts`}</span>
        <Icon className={s.arrow} icon="arrow-circle" />
      </Link>
    </Container>
  );
}

function Ellipses({ swiper, ellipses, ...props }) {
  if (!swiper) return null;
  const [activeEl, setActiveEl] = useState(0);
  const getAccurateSlideTo = (idx) => {
    if (window.innerWidth > 768) {
      return idx === 0 ? 0 : idx * 4 + 1;
    }
    return idx;
  };

  const handleActive = () => {
    if (window.innerWidth > 768) {
    setActiveEl(swiper.current.activeIndex === 0 ? 0 : swiper.current.activeIndex / 4);
    }
    return setActiveEl(swiper.current.activeIndex);
  };

  useEffect(() => {
    if (swiper && swiper.current) {
      swiper.current.on('slideChange', handleActive);
    }
  }, [swiper]);

  useEffect(() => {
    if (swiper && swiper.current) {
      handleActive();
    }
  }, [ellipses]);

  return (
    <div className={`${s.ellipses} ${ellipses ? s.ready : ''}`}>
      {ellipses && (
        <button
          onClick={() => {
            swiper?.current?.slidePrev();
            setActiveEl(window.innerWidth >= 768 ? swiper?.current?.activeIndex / 4 : swiper?.current?.activeIndex);
          }}
          type="button"
          className={`${s.ellipse} ${s.ellipseNav} ${s.beginning} ${
            swiper?.current?.activeIndex !== 0 ? s.activeNav : s.disable
          }`}
        >
          <span className={s.icon}>
            <Icon icon="chevron-left" />
          </span>
        </button>
      )}
      {ellipses &&
        ellipses.map((ellipse, idx) => {
          const active = activeEl === idx;
          const isLast = ellipses.length - 1 === idx;
          return (
            // eslint-disable-next-line react/no-array-index-key
            <button
              key={idx}
              type="button"
              onClick={() => {
                swiper?.current?.slideTo(getAccurateSlideTo(idx));
                setActiveEl(window.innerWidth >= 768 ? swiper?.current?.activeIndex / 4 : swiper?.current?.activeIndex);
              }}
              className={`${s.ellipse} ${active ? s.active : ''} ${
                isLast ? s.last : ''
              }`}
            >
              {idx + 1}
            </button>
          );
        })}
      {ellipses && (
        <button
          type="button"
          onClick={() => {
            swiper?.current?.slideNext();
            setActiveEl(window.innerWidth >= 768 ? swiper?.current?.activeIndex / 4 : swiper?.current?.activeIndex);
          }}
          className={`${s.ellipse} ${s.ellipseNav} ${s.end} ${
            activeEl !== 3 ? s.activeNav : s.disable
          }`}
        >
          <span className={s.icon}>
            <Icon icon="chevron-right" />
          </span>
        </button>
      )}
    </div>
  );
}
